import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import "./index.css";
import axios from "axios";
import UrlLinks from "../../../UrlLinks";
import { useHistory, useParams } from "react-router-dom";
import styles from "./index.module.scss";
import { AppData } from "../../../context/context";
import { useContext } from "react";
import Header from "../components/Header";
import AgeRequirement from "../components/AgeRequirement";
import GenderLanguage from "../components/GenderLanguage";
import EducationAssetRequirement from "../components/EducationAssetRequirement";
import Footer from "../components/Footer";

const useStyles = makeStyles({});

const EligibilityCriteriaForm = (data) => {
  const classes = useStyles();
  const { jobId } = useParams();
  const history = useHistory();
  const {
    Loader,
    formMode,
    setFormMode,
    jobConfigMode,
    eligibilityJobId,
    eligibilityOptionList,
    setEligibilityOptionList,
  } = useContext(AppData);

  /* Other states */

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({
    ageError: { flag: false, message: { fromAge: "", toAge: "" } },
  });
  const [isDisable, setIsDisable] = useState(false);
  const [formData, setFormData] = useState({
    assets: [],
    documents: [],
    education: [],
    experience: [],
    fromAge: "",
    gender: [],
    jobDesc: "",
    jobTitle: "",
    jobType: "",
    jobTypeLocation: "",
    language: [],
    locationType: "",
    mustHaveAge: null,
    mustHaveAssets: null,
    mustHaveEducation: null,
    mustHaveGender: null,
    mustHaveLanguage: null,
    projectName: "",
    skills: [],
    toAge: "",
  });

  const cardView1 = [
    {
      id: null,
      title: "Age Requirements",
      valueKey: "",
      placeHolder: "Set the minimum and maximum age limits for eligibility",
      type: "header",
    },
    {
      id: 1,
      title: "Minimum Age",
      valueKey: "fromAge",
      placeHolder: "Type Minimum Age",
      type: "textbox",
    },
    {
      id: 2,
      title: "Maximum Age",
      valueKey: "toAge",
      placeHolder: "Type Maximum Age",
      type: "textbox",
    },
    {
      id: null,
      title: "Current range",
      valueKey: "",
      placeHolder: "",
      type: "answer-box",
    },
  ];
  const cardView2 = [
    {
      title: "Gender",
      valueKey: "gender",
      placeHolder: "Select gender requirements for eligibility",
      placeHolder1: "Select gender option",
      list: eligibilityOptionList.genderList,
      type: "dropdown",
      multipleFlag: false,
    },
    {
      title: "Language",
      valueKey: "language",
      placeHolder: "Select required languages",
      placeHolder1: "Select language",
      list: eligibilityOptionList.languageList,
      type: "dropdown",
      multipleFlag: true,
    },
  ];
  const cardView3and4 = [
    {
      id: 3,
      title: "Education",
      valueKey: "education",
      placeHolder: "Minimum education requirement",
      list: eligibilityOptionList.educationList,
      type: "radio",
      isDisabled: false,
    },
    {
      id: 4,
      title: "Assets Requirements",
      valueKey: "assets",
      placeHolder: "Select required asset types for eligibility verification",
      list: eligibilityOptionList.assetList,
      type: "checkbox",
      isDisabled: false,
    },
  ];

  const makeShiftList = (data) => {
    let list = [];
    data.map((el) => {
      list.push({
        id: el.id,
        name: el.typeValue,
      });
      return true;
    });
    return list;
  };

  const handleSaveBtn = () => {
    try {
      const mainData = { ...formData };
      const formData1 = new FormData();
      const body = JSON.stringify({
        age_from: +mainData.fromAge,
        age_to: +mainData.toAge,
        assets: mainData.assets
          ? mainData.assets.map((obj) => obj.id).join(",")
          : "",
        documents: mainData.documents.length
          ? mainData.documents.map((obj) => obj.id).join(",")
          : "",
        education: mainData.education ? mainData.education.id : null,
        experience: mainData.experience ? mainData.experience.id : null,
        gender: mainData.gender ? mainData.gender.id : null,
        jobId: jobId !== "add" ? +jobId : +eligibilityJobId,
        language: mainData.language
          ? mainData.language.map((obj) => obj.id).join(",")
          : "",
        skills: mainData.skills
          ? mainData.skills.map((obj) => obj.id).join(",")
          : "",
        ageMust: mainData.fromAge && mainData.toAge ? 1 : null,
        genderMust:
          mainData.gender !== null &&
          Object.keys(mainData.gender || {}).length !== 0
            ? 1
            : null,
        educationMust:
          mainData.education !== null &&
          Object.keys(mainData.education || {}).length !== 0
            ? 1
            : null,
        langMust: mainData.language.length ? 1 : null,
        assetsMust: mainData.assets.length ? 1 : null,
      });
      formData1.append("eligibilityBody", body);
      formData1.append("page2", JSON.stringify(mainData));

      const userId = localStorage.getItem("userID");

      axios
        .post(
          `${UrlLinks.baseUrl}task-job/addEditJob?insertedBy=${userId}`,
          formData1,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "*/*",
            },
          }
        )
        .then((res) => {
          history.push(`/jobsdb/configuration/${jobId}`);
        });

      formData1.append("eligibilityBody", body);
      formData1.append("page2", JSON.stringify(mainData));
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleInputChange = (e, type, val) => {
    const regexNumber = /^[1-9]\d*$/;

    switch (type) {
      case 1: {
        if (!e.target.value || regexNumber.test(e.target.value)) {
          setFormData((prev) => ({
            ...prev,
            fromAge: e.target.value,
          }));
        }
        break;
      }
      case 2: {
        if (!e.target.value || regexNumber.test(e.target.value)) {
          setFormData((prev) => ({
            ...prev,
            toAge: e.target.value,
          }));
        }
        break;
      }
      case 3: {
        setFormData((prev) => ({
          ...prev,
          education: val,
        }));
        break;
      }
      case 4: {
        setFormData((prev) => {
          const currentSelections = prev.assets || [];
          const newSelections = e.target.checked
            ? [...currentSelections, val]
            : currentSelections.filter((item) => item.id !== val.id);

          return {
            ...prev,
            assets: newSelections,
          };
        });
        break;
      }
      default:
        break;
    }
  };

  const handleError = () => {
    let fromAgeError = "";
    let toAgeError = "";
    if (formData.fromAge && formData.fromAge < 18) {
      fromAgeError = "Minimum age must be 18 or above";
    } else if (formData.fromAge && formData.fromAge > 60) {
      fromAgeError = "Minimum age is invalid";
    }
    if (formData.toAge && formData.toAge > 60) {
      toAgeError = "Maximum age must be 60 or below";
    } else if (
      formData.toAge &&
      (formData.toAge < 18 ||
        (formData.fromAge && formData.fromAge > formData.toAge))
    ) {
      toAgeError = "Maximum age is invalid";
    }
    setError((prev) => ({
      ...prev,
      ageError: {
        flag: fromAgeError || toAgeError ? true : false,
        message: {
          fromAge: fromAgeError,
          toAge: toAgeError,
        },
      },
    }));
  };

  /* UseEffects */

  useEffect(() => {
    if (
      error.ageError.flag ||
      (formData.fromAge && !formData.toAge) ||
      (!formData.fromAge && formData.toAge)
    ) {
      setIsDisable(true);
      return;
    } else {
      setIsDisable(false);
    }
  }, [error, formData]);

  useEffect(() => {
    handleError();
  }, [formData]);

  useEffect(async () => {
    setIsLoading(true);
    let currentFormMode = "create";
    // window.scrollTo(0, 0);

    await axios
      .get(`${UrlLinks.baseUrl}task-job/jobConfigValues`)
      .then((response) => {
        setEligibilityOptionList((prev) => ({
          ...prev,
          assetList: makeShiftList(response.data.assets),
          documentList: makeShiftList(response.data.document),
          educationList: makeShiftList(response.data.education),
          experienceList: makeShiftList(response.data.experience),
          genderList: makeShiftList(response.data.gender),
          languageList: makeShiftList(response.data.language),
          shiftTimings: makeShiftList(response.data.shift),
          skillList: makeShiftList(response.data.skills),
        }));
      });

    if (jobId !== "add") {
      await axios
        .get(`${UrlLinks.baseUrl}task-job/${jobId}`)
        .then((response) => {
          const newEligibilityData = response.data.page2
            ? JSON.parse(response.data.page2)
            : { ...formData };
          setFormData(newEligibilityData);
        });
    }

    setFormMode(currentFormMode);
    setIsLoading(false);
  }, []);

  return (
    <>
      {isLoading ? (
        Loader()
      ) : (
        <>
          <Box
            style={{
              padding: "50px 80px",
              boxSizing: "border-box",
              backgroundColor: "#f7fafc",
            }}
          >
            <Grid container className={styles.mainBox}>
              <Grid item xs={12} container className={`flexDisplay`}>
                <Header
                  uniqueKey="eligibilityCriteria"
                  title={
                    jobConfigMode === "create"
                      ? "Add Job Eligibility Criteria 2/3"
                      : jobConfigMode === "view"
                      ? "View Job Eligibility Criteria"
                      : "Eligibility Criteria"
                  }
                  helperText="Define detailed eligibility rules to ensure that only the most suitable and qualified candidates are automatically considered for the job"
                  linkBack={`/jobsdb/jobConfig/${jobId}`}
                  isLoading={isLoading}
                  setIsLoading={setIsLoading}
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                sx={{
                  justifyContent: "space-between",
                  rowGap: "40px",
                }}
                className={`${styles.cardContainer}`}
              >
                <AgeRequirement
                  uniqueKey="eligibilityCriteria"
                  cardView={cardView1}
                  eligibilityData={formData}
                  handleInputChange={handleInputChange}
                  error={error}
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                sx={{
                  justifyContent: "space-between",
                  rowGap: "40px",
                }}
              >
                {cardView2?.map((ele, id) => (
                  <Grid
                    key={id}
                    item
                    sx={{
                      flex: "0 0 49%",
                      maxWidth: "49%",
                    }}
                    className={`${styles.cardContainer}`}
                  >
                    <GenderLanguage
                      uniqueKey="eligibilityCriteria"
                      data={ele}
                      eligibilityData={formData}
                      setEligibilityData={setFormData}
                    />
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={12} container sx={{ rowGap: "24px" }}>
                {cardView3and4?.map((ele, id) => (
                  <Grid
                    item
                    xs={12}
                    key={id}
                    className={`${styles.cardContainer}`}
                  >
                    <EducationAssetRequirement
                      uniqueKey="eligibilityCriteria"
                      data={ele}
                      eligibilityData={formData}
                      handleChange={handleInputChange}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Box>
          {formMode !== "view" && (
            <Footer
              uniqueKey="eligibilityCriteria"
              isLoading={isLoading}
              button1="Cancel"
              button2="Next"
              linkButton1="/jobsdb"
              handleSaveBtn={handleSaveBtn}
              isDisabled={isDisable || isLoading}
            />
          )}
        </>
      )}
    </>
  );
};

export default EligibilityCriteriaForm;
